import {HTMLPageView} from '@fantasmagames/core/src/html/HTMLPageView';
import {RecordData} from '@fantasmagames/slot/src/config/GameConfig';

export interface IParagraph {
	title: string;
	text: string[];
}

export interface ITextFormatOptions {
	anchor: {x: number; y: number};
	offset: {x: number; y: number};
	rotation: number;
}

export class GameRulesView extends HTMLPageView {
	public init(): void {
		super.init();
	}

	protected setupHTML(): void {
		super.setupHTML();

		this.replaceGameVersion();
		this.formatGameInfoValue();
		this.bindButtons();
	}

	protected setupPathsAndIds(): void {
		this._resourcesPath = 'HTML/GAMERULES/';
		this._containerId = 'FANTASMA_GAMERULES_CONTAINER';
	}

	protected formatGameInfoValue(): void {}

	protected getBodyContent(): string {
		return this.resources.getGameRulesHTML();
	}

	protected getIframeContent(): string {
		return this.resources.getGameRulesHTML();
	}

	public replaceRTPData(config: RecordData): void {
		for (const data in config.record) {
			const rtpSeparator: string = this.translator.getObject('BaseStrings', 'generic', 'g_rtpSeparator');
			const dataValue = config.getParameter(data);

			if (data && typeof dataValue === 'number') {
				let rtpValue = String(dataValue);
				rtpValue = rtpValue.replace('.', rtpSeparator);

				this._mainBody.innerHTML = this._mainBody.innerHTML.replace(`¤¤¤${data}¤¤¤`, rtpValue);
			}
		}
	}

	public replaceGameVersion(version?: string): void {
		const versionItem: HTMLElement = this.findChildWithId('¤¤¤GAMEVERSION¤¤¤', this._mainBody);

		if (version) {
			versionItem.innerText = version;
		} else if (versionItem) {
			versionItem.innerText = __VERSION__;
		}
	}

	public replaceRelaxTimeStamp(timestamp: string): void {
		const versionItem: HTMLElement = this.findChildWithId('¤¤¤BUILDDATE¤¤¤', this._mainBody);

		if (versionItem) {
			versionItem.innerText = timestamp;
		}
	}

	protected findChildWithId(id: string, inElement: HTMLElement): HTMLElement {
		const childNodes = Array.prototype.slice.call(inElement.childNodes);

		for (const child of childNodes) {
			if (child && child.id) {
				if (child.id === id) {
					return child;
				}
			}
		}

		return null;
	}

	protected bindButtons(): void {}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/gamerules/GameRulesView.ts